/**
 * ProjectDocumentService
 * Service for ProjectDocument entity operations
 * Route: api/project-documents
 * Controller: ProjectDocumentController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ProjectDocumentService
 * Handles project document CRUD operations
 * Maps to /api/project-documents endpoint
 */
export class ProjectDocumentService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProjectDocumentService.DEFAULT_SERVICE_PATH,
            basePath: ProjectDocumentService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
ProjectDocumentService.DEFAULT_SERVICE_PATH = 'projects';
ProjectDocumentService.BASE_PATH = 'api/project-documents';
//# sourceMappingURL=ProjectDocumentService.js.map